module.exports = __webpack_public_path__ + "img/4.b4ee66c5.svg";